import $ from 'jquery';

export const init = ($target) => {
	const DOWN_ARROW_KEY_CODE = 40,
		UP_ARROW_KEY_CODE = 38,
		ESCAPE_KEY_CODE = 27,
		SPACEBAR_KEY_CODE = 0 || 32;

	const $socialLink = $('.js-social-link'),
		$shareBox = $('.js-share-box'),
		$shareItem = $('.js-share-item'),
		$animWrap = $shareBox.closest('.js-relevate');

	function clickOutside(event) {
		// if the target of the click isn't the container nor a descendant of the container
		if (!$shareItem.is(event.target) && $shareItem.has(event.target).length === 0) {
			$shareBox.removeClass('is-active');
			$animWrap.removeClass('has-overflow');
			$target.off('click', clickOutside);
		}
	}

	function toggleShare(event) {
		event.preventDefault();
		$shareBox.toggleClass('is-active');
		if ($animWrap.hasClass('visible')) {
			$animWrap.addClass('has-overflow');
		}
		$target.on('click', clickOutside);
	}

	function onSpaceKey(e) {
		if (!$socialLink.is(':focus')) {
			return;
		}

		e.preventDefault();
		$shareBox.toggleClass('is-active');
		$animWrap.toggleClass('has-overflow');
	}

	function onEscapeKey(e) {
		$shareBox.removeClass('is-active');
		if ($animWrap.hasClass('visible')) {
			$animWrap.removeClass('has-overflow');
		}
		e.stopPropagation();
	}

	function onArrowKey(e) {
		const $socialItems = $shareBox.find('.share__social-item .share__social'),
			$focusedItem = $shareBox.find('.share__social-item .share__social:focus'),
			focusedItemIndex = $socialItems.index($focusedItem),
			maxIndex = $socialItems.length - 1;

		if (!$socialItems.length || !$shareBox.hasClass('is-active')) {
			return;
		}

		e.preventDefault();

		const nextIndex = e.keyCode === DOWN_ARROW_KEY_CODE ? focusedItemIndex + 1 : focusedItemIndex - 1;

		if (nextIndex > maxIndex) {
			return;
		}

		const $nextItem = nextIndex < 0 ? $socialLink : $socialItems.eq(nextIndex);

		$nextItem.trigger('focus');
	}

	$socialLink.on('click', toggleShare);
	$target.on('keydown', function (e) {
		if (e.keyCode === ESCAPE_KEY_CODE || e.code === 'Escape') {
			onEscapeKey(e);
			return;
		}

		if (e.keyCode === SPACEBAR_KEY_CODE || e.code === 'Space') {
			onSpaceKey(e);
			return;
		}

		if (e.keyCode === DOWN_ARROW_KEY_CODE || e.keyCode === UP_ARROW_KEY_CODE) {
			onArrowKey(e);
			return;
		}
	});
};
